import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setCriteriaChanged({ commit }, value) {
    commit(types.SET_CRITERIA_CHANGED, value)
  },
  setTools({ commit }, data) {
    commit(types.RESET_TOOLS, data)
  },
  async getTools({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getTools', () =>
      http.get('dispatch/GetTools')
    )
    commit(types.SET_TOOLS, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/actions.js